import { render, staticRenderFns } from "./UserWrapper.vue?vue&type=template&id=35b3a8bc&"
import script from "./UserWrapper.vue?vue&type=script&lang=ts&"
export * from "./UserWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports